import formatDistance from "date-fns/formatDistance";
import { Batch } from "@wingspanhq/wingspan-api-sdk";

export const selectorImportBatchAge = (batch?: Batch): string => {
  const createdAt = batch?.events?.createdAt;
  if (!createdAt) {
    return "";
  }

  return formatDistance(new Date(createdAt), new Date());
};
